export default class AddressModel  {
    timezone: string = "";
    latitude: number = 0;
    longitude: number = 0;

    static from(json: string): AddressModel {
        let model = Object.assign(new AddressModel(), json);
        return model;
    }
}